export function isPromise(obj) {
    return typeof obj === 'object' && (obj instanceof Promise || typeof obj.then === 'function');
}
